import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import classnames from 'classnames';
import { Button } from 'reactstrap';

export function DealerReviewSubmitButton({ isLoading = false, onClick = noop, children }) {
  return (
    <Button
      type="submit"
      color="primary-b"
      size="lg"
      className={classnames('btn-step-submit fw-normal text-transform-none my-1_5', {
        'spinner-active': isLoading,
      })}
      onClick={onClick}
      disabled={isLoading}
      data-tracking-id="dealer_review_submit"
      data-test="submit-btn"
    >
      <i className="spinner icon-spinner8 me-0_25" aria-hidden />
      {children}
    </Button>
  );
}

DealerReviewSubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
};
